export enum Integrator {
  DRAKE = 'Drake',
  CCH = 'CCH',
}
